import api from '../index';
import QueryContext from '../QueryContext';

const campaignFetchers = {
  campaign: (context: QueryContext) =>
    api.get(`/campaigns/${context.meta?.id}`, {}),
};
export default campaignFetchers;
